import { useParams } from "react-router-dom";

import blogData from "../data/blogData";

export default function BlogDetail() {
    const { title } = useParams();
    // Helper function to generate a URL-friendly slug from title
    const slugify = (str) =>
        str.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)+/g, "");

    // Find the blog by comparing the slugified title
    const blog = blogData.blogs.find(
        (b) => slugify(b.title) === title.toLowerCase()
    );

    const imageUrl = blog.img

    console.log("blog", blog)
    if (!blog) {
        return <div>Blog not found.</div>;
    }
    return (
        <div className="" style={{background:"#faf7f0"}}>
            <div className="post_header_wrap post_header_wrap_in_header post_header_wrap_style_style-1 with_featured_image">
                <div
                    className="post_featured with_thumb post_featured_bg agricola_inline_366363072"
                    style={{ minHeight: 0, backgroundImage: `url(${imageUrl})`,
                     }}
                />{" "}
                <div className="post_header post_header_single entry-header">
                    <div className="">
                        <div className="post_meta post_meta_categories">
                            <span className="post_meta_item post_categories">
                                <a
                                    href="/blog"
                                    rel="category tag"
                                    style={{background:"#f2c200",color:"#401e15"}}
                                >
                                    Blog
                                </a>
                            </span>
                        </div>
                        <h1 className="post_title entry-title">
                            {blog.title}
                        </h1>

                    </div>
                </div>
            </div>
            <div className="content_wrap " style={{ paddingTop: "6rem" }}>
                <div className="content" style={{ width: "calc( 1290px - clamp( 150px, calc( 1290px * 0.31782945736434 * 1 + 410px * ( 1 - 1 ) ), 500px ) - clamp( 0px, calc( 1290px * 0.031007751937984 * 1 + 40px * ( 1 - 1 ) ), 100px ) )", margin: "auto" }}>
                    <span
                        id="content_skip_link_anchor"
                        className="agricola_skip_link_anchor"
                    />
                    <article
                        style={{ width: "75%", margin: "0 auto" }}
                        id="post-275"
                        className="post_item_single post_type_post post_format_ post-275 post type-post status-publish format-standard has-post-thumbnail hentry category-organic tag-agriculture tag-buy tag-crop tag-eco tag-equipment tag-farm tag-food"
                    >
                        <div className="post_content post_content_single entry-content">
                            <p>
                                <span className="trx_addons_dropcap trx_addons_dropcap_style_2">
                                    {blog.q}
                                </span>
                                {blog.desc}
                            </p>
                            <p>
                                {blog.content.introduction2}
                            </p>
                            {blog.content.sections.map((section, index) => (<>
                                <h5 className="wp-block-heading">{section.heading}</h5>
                                <p>
                                    {section.body}
                                </p>
                            </>))}

                            <blockquote className="wp-block-quote is-layout-flow wp-block-quote-is-layout-flow bg-white">
                                <p>
                                    {blog.content.quote?.text}
                                </p>
                                <cite>{blog.content.quote?.author}</cite>
                            </blockquote>
                            {/* <p>
                                Ut perspiciatis, unde omnis iste natus error sit voluptatem
                                accusantium doloremque laudantium, totam rem aperiam eaque ipsa,
                                quae ab illo inventore veritatis et quasi architecto beatae vitae
                                dicta sunt, explicabo.
                            </p> */}
                            <div
                                style={{ height: 20 }}
                                aria-hidden="true"
                                className="wp-block-spacer"
                            />

                            <h5 className="wp-block-heading">
                                {blog.Companies?.text}
                            </h5>
                            <p>
                                {blog.Companies?.heading}
                            </p>
                            <h5 className="wp-block-heading">
                                {blog.Solutions?.text}
                            </h5>
                            <p>
                                {/* {blog.Solutions.heading} */}
                                <ul>
                                    {blog.Solutions?.heading
                                        .split("") // split string into bullet items
                                        .filter(item => item.trim() !== "") // remove empty items
                                        .map((item, index) => (
                                            <li key={index}>{item.trim()}</li>
                                        ))}
                                </ul>
                            </p>
                            {/* <p>
                                Etiam vitae leo et diam pellentesque porta. Sed eleifend ultricies
                                risus, vel rutrum erat commodo ut. Praesent finibus congue euismod.
                                Nullam scelerisque massa vel augue placerat, a tempor sem egestas.
                                Curabitur placerat finibus lacus.
                            </p> */}
                        </div>
                        {/* tags */}
                        <div className="post_footer post_footer_single entry-footer">
                            <div className="post_tags_single">
                                <span className="post_meta_label">Tags:</span>{" "}
                                {blog.tags.map((section, index) => (<a
                                    href="/"
                                    rel="tag" key={index}
                                    style={{padding:"8px 18px 9px",margin:"0.25em 0.5em 0.25em 0",border:"1px solid #DDDAD3",fontSize:"13px",fontWeight:"400",color:"#615D58"}}
                                >
                                    {section}
                                </a>))}

                            </div>
                            <div className="post_meta post_meta_single">
                                <a
                                   type="button"
                                    role="button"
                                    className=""
                                    // title="Like"
                                    // data-postid={275}
                                    // data-likes={4}
                                    // data-title-like="Like"
                                    // data-title-dislike="Dislike"
                                >
                                    {/* <span className="post_meta_number">4</span> */}
                                    {/* <span className="post_meta_label">Likes</span> */}
                                </a>
                                <span className="post_meta_item post_share">
                                    <span className="socials_share socials_size_tiny socials_type_block socials_dir_horizontal socials_wrap">
                                        <span className="social_items inited">
                                            <a
                                                className="social_item social_item_popup"
                                                href="https://www.linkedin.com/company/golden-agriculture-company/"
                                                data-link="https://www.linkedin.com/company/golden-agriculture-company/"
                                                data-count="twitter-new"
                                            >
                                                <span
                                                    className="social_icon social_icon_twitter-new sc_icon_type_icons"
                                                    style={{}}
                                                >
                                                    <span className="screen-reader-text">Twitter-new</span>
                                                                                <i className="fa-brands fa-linkedin-in"></i>

                                                </span>
                                            </a>
                                            <a
                                                className="social_item social_item_popup"
                                                href="https://www.facebook.com/profile.php?id=61578623335415"
                                                data-link="https://www.facebook.com/profile.php?id=61578623335415"
                                                data-count="facebook-1"
                                            >
                                                <span
                                                    className="social_icon social_icon_facebook-1 sc_icon_type_icons"
                                                    style={{}}
                                                >
                                                    <span className="screen-reader-text">Facebook</span>
                                                                                 <i className="fa-brands fa-facebook-f"></i>

                                                </span>
                                            </a>
                                            <a
                                                className="social_item"
                                                href="https://www.instagram.com/goldenagriculture___/"
                                                target="_blank"
                                                data-count="share-email"
                                            >
                                                <span
                                                    className="social_icon social_icon_share-email sc_icon_type_icons"
                                                    style={{}}
                                                >
                                                    <span className="screen-reader-text">Share-email</span>
                                                                                <i className="fa-brands fa-instagram"></i>

                                                </span>
                                            </a>
                                          
                                        </span>
                                    </span>
                                </span>
                            </div>{" "}


                        </div>
                    </article>

                    <section className="related_wrap related_position_below_content related_style_classic">
                        <h3 className="section_title related_wrap_title">You May Also Like</h3>
                        <div className="columns_wrap posts_container columns_padding_bottom inited_open_full_post">
                            <div className="column-1_2">
                                <div
                                    id="post-17907"
                                    className="related_item post_format_standard post-17907 post type-post status-publish format-standard has-post-thumbnail hentry category-organic tag-agriculture tag-buy tag-crop tag-eco tag-equipment tag-farm tag-food"
                                    data-post-id={17907}
                                >
                                    <div className="post_featured with_thumb hover_link">
                                        <img
                                            width={890}
                                            height={664}
                                            src="/img/blog/blog4.jpg"
                                            className="attachment-agricola-thumb-square size-agricola-thumb-square wp-post-image"
                                            alt=""
                                            decoding="async"
                                        />{" "}
                                        <div className="mask" />
                                        <a
                                            href="/grain-market-outlook-2025-trends-risks-and-opportunities"
                                            aria-hidden="true"
                                            className="link"
                                        />
                                    </div>{" "}
                                    <div className="post_header entry-header">
                                        <div className="post_meta post_meta_categories">
                                            <span className="post_meta_item post_categories cat_sep">
                                                <a
                                                    href="/grain-market-outlook-2025-trends-risks-and-opportunities"
                                                    rel="category tag"
                                                >
                                                     October 7, 2025
                                                </a>
                                            </span>
                                        </div>{" "}
                                        <h6 className="post_title entry-title">
                                            <a href="/middle-east-food-security-the-strategic-role-of-grain-imports">
                                                Grain Market Outlook 2025: Trends, Risks, and Opportunities
                                            </a>
                                        </h6>
                                    </div>
                                </div>
                            </div>
                            <div className="column-1_2">
                                <div
                                    id="post-17904"
                                    className="related_item post_format_standard post-17904 post type-post status-publish format-standard has-post-thumbnail hentry category-organic tag-agriculture tag-buy tag-crop tag-eco tag-equipment tag-farm tag-food"
                                    data-post-id={17904}
                                >
                                    <div className="post_featured with_thumb hover_link">
                                        <img
                                            width={890}
                                            height={664}
                                            src="/img/blog/blog3.jpg"
                                            className="attachment-agricola-thumb-square size-agricola-thumb-square wp-post-image"
                                            alt=""
                                            decoding="async"
                                        />{" "}
                                        <div className="mask" />
                                        <a
                                            href="/why-traceability-is-a-must-in-modern-agri-trade"
                                            aria-hidden="true"
                                            className="link"
                                        />
                                    </div>{" "}
                                    <div className="post_header entry-header">
                                        <div className="post_meta post_meta_categories">
                                            <span className="post_meta_item post_categories cat_sep">
                                                <a
                                                    href="/why-traceability-is-a-must-in-modern-agri-trade"
                                                    rel="category tag"
                                                >
                                                    October 7, 2025
                                                </a>
                                            </span>
                                        </div>{" "}
                                        <h6 className="post_title entry-title">
                                            <a href="/why-traceability-is-a-must-in-modern-agri-trade">
                                                Why Traceability Is a Must in Modern Agri-Trade
                                            </a>
                                        </h6>
                                    </div>
                                </div>
                            </div>
                        </div>{" "}
                    </section>
                </div>
            </div>
        </div>

    )
}

